import script from "./MomentLikesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MomentLikesModal.vue?vue&type=script&setup=true&lang=js"

import "./MomentLikesModal.vue?vue&type=style&index=0&id=1ad967d7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad967d7"]])

export default __exports__